import React, { useEffect, useRef } from 'react';
import Modal from './Modal';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'default',
}) => {
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const t = setTimeout(() => confirmBtnRef.current?.focus(), 30);
    const onKey = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        onConfirm();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => {
      clearTimeout(t);
      document.removeEventListener('keydown', onKey);
    };
  }, [isOpen, onConfirm]);

  const confirmClass =
    tone === 'danger'
      ? 'bg-red-500 hover:bg-red-600 text-white'
      : 'bg-accent text-white hover:opacity-90';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm" showCloseButton={false}>
      <div className="space-y-4">
        {message && (
          <p className="text-center text-text">{message}</p>
        )}
        <div className="flex gap-3 mt-6 pt-4 border-t border-secondary">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 text-text hover:bg-secondary rounded-lg transition-colors inline-flex items-center justify-center gap-2"
          >
            <span>{cancelLabel}</span>
            <Kbd>esc</Kbd>
          </button>
          <button
            type="button"
            ref={confirmBtnRef}
            onClick={onConfirm}
            className={`flex-1 px-4 py-2 rounded-lg transition-colors font-medium inline-flex items-center justify-center gap-2 ${confirmClass}`}
          >
            <span>{confirmLabel}</span>
            <Kbd invert>↵</Kbd>
          </button>
        </div>
      </div>
    </Modal>
  );
};

function Kbd({ children, invert = false }) {
  return (
    <kbd
      className={`font-mono text-[10px] leading-none px-1.5 py-0.5 rounded border ${
        invert
          ? 'bg-white/20 border-white/30 text-white'
          : 'bg-secondary border-neutral-700 text-text opacity-80'
      }`}
    >
      {children}
    </kbd>
  );
}

export default ConfirmModal;
